import { generatePath } from 'react-router-dom';

import {
  PRIVATE_INTERACTIVE_LESSON_PRESENT,
  PRIVATE_INTERACTIVE_LESSON_EDIT,
  PRIVATE_INTERACTIVE_LESSON_CREATE,
  PRIVATE_INTERACTIVE_LESSON_DRAFT,
  PRIVATE_INTERACTIVE_ASSESSMENT_PRESENT,
  PRIVATE_INTERACTIVE_ASSESSMENT_EDIT,
  PRIVATE_INTERACTIVE_ASSESSMENT_DRAFT,
  PRIVATE_INTERACTIVE_ASSESSMENT_CREATE,
  PRIVATE_INTERACTIVE_LESSON_STUDENT_PRESENT,
  PRIVATE_INTERACTIVE_ASSESSMENT_STUDENT_PRESENT,
} from 'global/private-routes.constants';
import { ExtraSectionIdentifiers } from './activity-builder.apollo';
import {
  LESSON_ACTIVITIES,
  ActivitiesContentType,
  LanguageCodes,
} from 'global/constants';
import { pathWithQueryParams } from 'lib/router/router.util';

export function getPresentationUrl({
  slug,
  userClassId,
  sectionId,
  contentType,
  version,
  lang,
}: {
  contentType: ActivitiesContentType;
  slug?: string;
  userClassId?: number | string;
  sectionId?: string;
  version?: string | null;
  lang?: string | null;
}) {
  return pathWithQueryParams(
    `${generatePath(
      contentType === LESSON_ACTIVITIES
        ? PRIVATE_INTERACTIVE_LESSON_PRESENT
        : PRIVATE_INTERACTIVE_ASSESSMENT_PRESENT,
      {
        userClassId: userClassId?.toString() || '',
        slug: slug || '',
      }
    )}`,
    {
      page: sectionId ? sectionId : ExtraSectionIdentifiers.Introduction,
      version: version ? version : undefined,
      lang: lang ? lang : undefined,
    }
  );
}

export function getStudentPresentationUrl({
  slug,
  sectionId,
  contentType,
  version,
  language,
  assignmentId,
  classId,
}: {
  contentType: ActivitiesContentType;
  slug?: string;
  sectionId?: string;
  version?: string | null;
  language?: LanguageCodes;
  assignmentId?: number | null;
  classId?: number;
}) {
  return pathWithQueryParams(
    `${generatePath(
      contentType === LESSON_ACTIVITIES
        ? PRIVATE_INTERACTIVE_LESSON_STUDENT_PRESENT
        : PRIVATE_INTERACTIVE_ASSESSMENT_STUDENT_PRESENT,
      {
        slug: slug || '',
      }
    )}`,
    {
      page: sectionId ? sectionId : ExtraSectionIdentifiers.Introduction,
      version: version ? version : undefined,
      lang: language ? language : undefined,
      assignmentId: assignmentId ? assignmentId : undefined,
      classId: classId ? classId : undefined,
    }
  );
}

export function getEditUrl({
  slug,
  userClassId,
  sectionId,
  contentType,
  version,
}: {
  contentType: ActivitiesContentType;
  slug?: string;
  userClassId?: number | string;
  sectionId?: string;
  version?: string | null;
}) {
  return pathWithQueryParams(
    `${generatePath(
      contentType === LESSON_ACTIVITIES
        ? PRIVATE_INTERACTIVE_LESSON_EDIT
        : PRIVATE_INTERACTIVE_ASSESSMENT_EDIT,
      {
        userClassId: `${userClassId}`,
        slug: slug || '',
      }
    )}`,
    {
      page: sectionId ? sectionId : ExtraSectionIdentifiers.Introduction,
      version: version ? version : undefined,
    }
  );
}

export function getDraftUrl({
  slug,
  userClassId,
  draftId,
  sectionId,
  contentType,
}: {
  contentType: ActivitiesContentType;
  slug?: string;
  userClassId?: string;
  draftId: string;
  sectionId?: string;
}) {
  return pathWithQueryParams(
    `${generatePath(
      contentType === LESSON_ACTIVITIES
        ? PRIVATE_INTERACTIVE_LESSON_DRAFT
        : PRIVATE_INTERACTIVE_ASSESSMENT_DRAFT,
      {
        userClassId: userClassId || '',
        slug: slug || '',
      }
    )}`,
    {
      draftId: draftId,
      page: sectionId ? sectionId : ExtraSectionIdentifiers.Introduction,
    }
  );
}

export function getCreateUrl({
  slug,
  userClassId,
  contentType,
}: {
  contentType: ActivitiesContentType;
  slug?: string;
  userClassId?: number;
}) {
  return `${generatePath(
    contentType === LESSON_ACTIVITIES
      ? PRIVATE_INTERACTIVE_LESSON_CREATE
      : PRIVATE_INTERACTIVE_ASSESSMENT_CREATE,
    {
      userClassId: `${userClassId}`,
      slug: slug || '',
    }
  )}`;
}
